<template>
    <div class="container" v-title="'报名公示'">
        <Navigation-bar v-scrollShadow="(itemIndex == -1 || itemTop != 0) && roll" title="报名公示">
            <span class="report" v-href="'/Enroll/Report?subLeagueId=' + subLeagueId">我要举报</span>
        </Navigation-bar>
        <div class="container_content">
            <div id="BulletinBoard" v-if="pageShow">
                <div class="BulletinBoard_scroll" v-scroll="roll">
                    <div class="match_title">
                        <p>{{title}}</p>
                        <p>{{PublicTimes > 1 ? `第${numberToChinese(PublicTimes)}期` : ''}}报名公示</p>
                    </div>
                    
                    <div class="synopsis rich_text" v-html="detail"></div>
                    <div class="member_list">
                        <div class="group" v-for="(item, index) in list" :key="index">
                            <div class="group_title" ref="group_title" :class="item.DeputationName && item.CompanyName ? 'h-1' : 'h-2'">
                                <div class="group_title_fixed" 
                                    :class="{'fixed': itemIndex == index}" 
                                    :style="{'top' : itemIndex == index ? itemTop + 'px' : ''}" 
                                    v-scrollShadow="(itemIndex == index && itemTop == 0) && roll"
                                >
                                    <div class="team_info">
                                        <div class="group_name">{{item.LeagueGroupName}}</div>
                                        <div class="team_name" v-if="item.DeputationName">{{item.DeputationName}}</div>
                                        <p class="team_company" v-if="!item.DeputationName && item.CompanyName">(代表机构：{{item.CompanyName}})</p>
                                    </div>
                                    <p class="team_company" v-if="item.DeputationName && item.CompanyName">(代表机构：{{item.CompanyName}})</p>
                                </div>
                            </div>
                            <ul v-if="item.TeamType != 3">
                                <li v-for="(memberItem, memberIndex) in item.MemberList" :key="memberIndex">
                                    <div>
                                        <div class="info">
                                            <span class="name">{{memberItem.Name}}</span>
                                            <span class="role">{{memberItem.EnrollRoleList[0].RoleName}}</span>
                                        </div>
                                        <div class="IDNumber">{{memberItem.IdentityNo || ''}}</div>
                                    </div>
                                    <p class="IDType" v-if="memberItem.IdentityType != 1">{{cards[memberItem.IdentityType]}}</p>
                                </li>
                            </ul>
                            <template v-else>
                                <div class="doubles" v-for="(doublesItem,doublesIndex) in item.DoublesList" :key="doublesIndex">
                                    <div class="doubles_title">{{doublesItem.PairName}}</div>
                                    <ul>
                                        <li v-for="(memberItem, memberIndex) in doublesItem.UserList" :key="memberIndex">
                                            <div>
                                                <div class="info">
                                                    <span class="name">{{memberItem.Name}}</span>
                                                    <span class="role">{{memberItem.EnrollRoleList[0].RoleName}}</span>
                                                </div>
                                                <div class="IDNumber">{{memberItem.IdentityNo || ''}}</div>
                                            </div>
                                            <p class="IDType" v-if="memberItem.IdentityType != 1">{{cards[memberItem.IdentityType]}}</p>
                                        </li>
                                    </ul>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    GetLeagueEnrollPublicNameList
} from "@/api"
import {
    numberToChinese
} from '@js';
export default {
    name:"BulletinBoard",
    data(){
        var subLeagueId = parseInt(this.$route.query.subLeagueId);
        return {
            subLeagueId: isNaN(subLeagueId) ? 0 : subLeagueId,
            pageShow: false,
            roll: 0,
            itemIndex:-1,//定位的下标
            itemTop:0,//定位的top
            title: "",
            detail: "",
            numberToChinese,
            list:[],
            cards:{
                1:'身份证（港澳台居住证）',
                2:'护照',
                4:'台湾居民来往大陆通行证',
                5:'港澳居民来往内地通行证'
            }
        }
    },
    created(){
        GetLeagueEnrollPublicNameList({
            "SubLeagueId": this.subLeagueId,
        }).then(data=>{
            if(data.Code == 0){
                this.pageShow = true;
                this.title = data.LeagueName;
                this.detail = data.PublicNotice;
                this.PublicTimes = data.PublicTimes;
                let TeamList = data.TeamList || [];
                for(var i=0;i<TeamList.length;i++){
                    let teamObj = TeamList[i];
                    if(teamObj.TeamType == 3){
                        let doublesObj = {},
                            doublesArr = [];
                        for(var j=0;j<teamObj.MemberList.length;j++){
                            let userInfo = teamObj.MemberList[j];
                            let arr = doublesObj[userInfo.PairId] || [];
                            arr.push(userInfo);
                            doublesObj[userInfo.PairId] = arr;
                        }
                        let num = 0;
                        for(var key in doublesObj){
                            num++;
                            doublesArr.push({
                                PairName: '组合' + numberToChinese(num),
                                UserList: doublesObj[key]
                            });
                        }
                        TeamList[i].DoublesList = doublesArr;
                    }
                }
                this.list = TeamList;
            }
        })
    },
    watch:{
        roll(newVal){
            var arr = this.$refs['group_title'];
            var index = -1;
            arr.forEach(function(item,i){
                let ItemTop = item.offsetTop;
                if(ItemTop < newVal){
                    index = i;
                }
            })
            if(index >= 0 && index + 1 < arr.length){
                let currentItemTop = 0;
                let nextItemTop = arr[index + 1].offsetTop - newVal;
                let currentItemH = arr[index].offsetHeight;
                if(nextItemTop < currentItemH){
                    currentItemTop = nextItemTop - currentItemH;
                }
                this.itemTop = currentItemTop;
            }
            this.itemIndex = index;
        }
    }
}
</script>
<style lang="scss" scoped>
.report{
    font-size: 28px;
    color: #1B1C1E;
    font-weight: 500;
}
#BulletinBoard {
    position: relative;
    .BulletinBoard_scroll{
        height: 100%;
        width: 100%;
        padding-top: 40px;
        box-sizing: border-box;
        overflow-y: auto;
    }
    .match_title{
        width: 540px;
        font-size: 32px;
        color: #1B1C1E;
        text-align: center;
        line-height: 52px;
        font-weight: 500;
        margin: 0 auto;
        margin-bottom: 32px;
    }
    .synopsis{
        padding: 0 40px;
        box-sizing: border-box;
        font-size: 28px;
        color: #4D5561;
        line-height: 44px;
        font-weight: 400;
        margin-bottom: 80px;
    }
    .member_list{
        margin-bottom: 70px;
        .group{
            width: 100%;
            height: auto;
            margin-bottom: 40px;
            .group_title{
                width: 100%;
                &.h-1,
                &.h-1 .group_title_fixed{
                    height: 130px;
                }
                &.h-2,
                &.h-2 .group_title_fixed{
                    height: 92px;
                }
                .group_title_fixed{
                    width: 100%;
                    padding: 24px 40px;
                    box-sizing: border-box;
                    background: #ffffff;
                    &.fixed{
                        position: absolute;
                        left: 0;
                    }
                    .team_info{
                        min-height: 44px;
                        display: flex;
                        justify-content: space-between;
                        font-size: 32px;
                        font-weight: 500;
                        line-height: 44px;
                        .group_name{
                            color: #1B1C1E;
                            word-break: break-all;
                            padding-right: 40px;
                            box-sizing: border-box;
                        }
                        .team_name{
                            color: #7AD21A;
				            white-space: nowrap;
                        }
                        .team_company{
                            margin-top: 4px;
				            white-space: nowrap;
                        }
                    }
                    .team_company{
                        font-size: 24px;
                        color: #8B8C8D;
                        text-align: right;
                        font-weight: 400;
                    }
                }
            }
            ul{
                height: auto;
                li{
                    width: 100%;
                    padding: 16px 40px;
                    box-sizing: border-box;
                    &:nth-of-type(2n - 1){
                        background: #FAFBFA;
                    }
                    >div{
                        min-height: 44px;
                        display: flex;
                        justify-content: space-between;
                        font-size: 28px;
                        font-weight: 400;
                        line-height: 40px;
                        .info{
                            .name{
                                display: inline-block;
                                width: 122px;
                                color: #1B1C1E;
                            }
                            .role{
                                color: #8B8C8D;
                            }
                        }
                        .IDNumber{
                            color: #1B1C1E;
                        }
                    }
                    .IDType{
                        font-size: 24px;
                        color: #8B8C8D;
                        text-align: right;
                        font-weight: 400;
                    }
                    >div + .IDType{
                        margin-top: 4px;
                    }
                }
            }
            .doubles{
                width: 100%;
                height: auto;
                &:nth-of-type(2n){
                    background: #FAFBFA;
                }
                .doubles_title{
                    width: 100%;
                    line-height: 72px;
                    font-size: 28px;
                    color: #1B1C1E;
                    font-weight: 500;
                    padding: 0 40px;
                    box-sizing: border-box;
                }
                ul li{
                    background: none;
                }
            }
        }
    }
}
</style>
<style lang="scss">
@import '@assets/scss/richText.scss';
</style>